import { Injectable, Inject } from '@angular/core';
import { Observable, of } from 'rxjs';

import { BrandService } from 'shared/brand/brand.service';
import { PriceSheetService } from 'shared/price-sheet/price-sheet.service';
import { MarketingCopyService } from 'shared/marketing-copy/marketing-copy.service';
import { ProductGroupsService } from 'shared/product-groups/product-groups.service';
import { CoreService } from 'shared/global-core/core.service';

import { productGroupsSegmentData } from './segment-data/product-groups-segment-data';
import { marketingCopySegmentData } from './segment-data/marketing-copy-segment-data';
import { coreSegmentData } from './segment-data/core-segment-data';
import { priceSheetSegmentData } from './segment-data/price-sheet-segment-data';
import {
  PRODUCT_GROUPS_NAME,
  MARKETING_NAME,
  CORE_NAME,
  PRICE_SHEETS_NAME,
} from './variables';

@Injectable()
export class BrandInformationService {

  constructor(
    @Inject(BrandService) private brandService: BrandService,
    @Inject(PriceSheetService) private priceSheetService: PriceSheetService,
    @Inject(MarketingCopyService) private marketingCopyService: MarketingCopyService,
    @Inject(ProductGroupsService) private productGroupsService: ProductGroupsService,
    @Inject(CoreService) private coreService: CoreService,
  ) {}

  getSegmentData(segment: string) {
    switch (segment) {
      case PRODUCT_GROUPS_NAME:
        return productGroupsSegmentData;
      case MARKETING_NAME:
        return marketingCopySegmentData;
      case CORE_NAME:
        return coreSegmentData;
      case PRICE_SHEETS_NAME:
        return priceSheetSegmentData;
      default:
        return {};
    }
  }

  getData(segment: string): Observable<any> {
    const brandId = this.brandService.getBrand();
    switch (segment) {
      case PRODUCT_GROUPS_NAME:
        return this.productGroupsService.fetch(brandId, true);
      case MARKETING_NAME:
        return this.marketingCopyService.fetchMarketCopy(brandId);
      case CORE_NAME:
        return this.coreService.fetch(brandId);
      case PRICE_SHEETS_NAME:
        return this.priceSheetService.fetchAll(brandId);
      default:
        return of({});
    }
  }
}
